import { render, staticRenderFns } from "./ParcoBinari.vue?vue&type=template&id=32ceff17&"
import script from "./ParcoBinari.vue?vue&type=script&lang=js&"
export * from "./ParcoBinari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports